import { i18n } from '@/plugins/i18n.client';
import DateFnsAdapter from '@date-io/date-fns';
import * as locales from 'date-fns/locale';
import { colors as palette } from '/src/styles/common/styles';
import { aliases } from 'vuetify/iconsets/md';

// import { aliases, fa } from 'vuetify/iconsets/fa';
// import { mdi } from 'vuetify/iconsets/mdi';
// make sure to also import the coresponding css
// import '@mdi/font/css/materialdesignicons.css'; // Ensure you are using css-loader
// import 'material-design-icons-iconfont/dist/material-design-icons.css';

// Icons
import { materialSymbols } from '@/plugins/helpers/materialSymbols';
import { vuetifyDefaults } from '@/plugins/helpers/vuetifyDefaults';

export const vuetifyOptions = {
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        dark: false,
        colors: {
          ...palette
          // background: '#F5F6FA',
          // 'on-surface': '#0C233C',
          // 'on-background': '#0C233C'
          // 'on-primary': '#FFFFFF',
          // 'on-textLightGray': '#FFFFFF',
          // 'on-warning': '#FFFFFF'
        },
        variables: {
          'high-emphasis-opacity': 1,
          'hover-opacity': 0
        }
      }
    }
  },
  icons: {
    defaultSet: 'ms',
    aliases: { ...aliases, checkboxOn: aliases.checkboxOn + '--filled' },
    sets: {
      ms: materialSymbols
    }
  },
  defaults: vuetifyDefaults,
  lang: {
    t: (key, ...params) => i18n.global.t(key, params)
  },
  date: {
    adapter: DateFnsAdapter,
    locale: { ...locales, en: locales.enUS }
  },
  datepicker: {
    header: false
  }
};

export default vuetifyOptions;
